import script from "./RegionalPriceExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionalPriceExplorer.vue?vue&type=script&setup=true&lang=js"

import "./RegionalPriceExplorer.vue?vue&type=style&index=0&id=4ff158e6&scoped=true&lang=css"
script.__scopeId = "data-v-4ff158e6"

export default script